import React from 'react';

interface Props {
    value: string;
    handleChange: (event: React.ChangeEvent) => void;
}

export default function SearchInput({ value, handleChange }: Props) {
    return (
        <div
            className='position-relative border'
            style={{
                borderRadius: 10,
            }}
        >
            <input
                type='text'
                value={value}
                onChange={handleChange}
                className='form-control  px-4'
                placeholder='Buscar...'
                style={{
                    borderRadius: 10,
                    border: 'none',
                }}
            />
            <span
                className='text-muted fs-16 position-absolute mdi mdi-magnify search-widget-icon'
                style={{
                    top: 'calc(25% - 2px)',
                    left: '5px',
                }}
            ></span>
        </div>
    );
}
